export default __webpack_public_path__ + "static/media/bentobox-logo.9c87be63.png";